import { AdminContainer } from '@/components/containers/containers.component';
import { EditProjectForm } from '@/components/forms/edit-project.form.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

export default function EditProject() {
  return (
    <IfPermitted permissions={[UserPermissions.EDIT_PROJECT]}>
      <AdminContainer className={cn('flex flex-col')} title="Edit Project">
        <EditProjectForm />
      </AdminContainer>
    </IfPermitted>
  );
}
